module.exports = __webpack_public_path__ + "img/selectPayTypeBtnBg.1dd8f889.png";